import {Injectable, Injector} from '@angular/core';
import {PlayerBaseService} from './player.base.service';
import {Observable, Subject} from 'rxjs';
import {lastMap} from "../../rxjs/lastMap";
import {take} from "rxjs/operators";
import {Log} from "../Log";
import {PlayerPwaService} from "./player.pwa.service";


@Injectable({
  providedIn: 'root'
})
export class PlayerStudioService extends PlayerBaseService {
  constructor(protected  injector: Injector) {
    super(injector);
  }

  init(): Observable<any> {
    return super.init().pipe(
      lastMap(r=> this.caching.init(false, true))
    );
  }

  getServiceUrl() {
    return 'https://' + this.businessDomain +
      '/Web/loadData.ashx?businessId=' + this.businessId +
      '&sceneId=' + this.sceneId;
  }


  requestFont(i_font: string, onUrl: Function): void {
    const url = 'https://earth.signage.me/WebService/fonts/' + i_font;
    onUrl(url);
  }
}
